import React, { useState, useEffect } from 'react'

export default function InventoryReportsSidebar({
  warehouseFilter,
  reportTypeFilter,
  startDate,
  endDate,
  warehouses
}) {
  const [filters, setFilters] = useState({
    warehouse_id: warehouseFilter || '',
    report_type: reportTypeFilter || '',
    start_date: startDate || '',
    end_date: endDate || ''
  })

  const reportTypes = [
    { value: 'snapshot', label: 'Snapshot' },
    { value: 'movement', label: 'Movement' },
    // { value: 'variance', label: 'Variance' },
    { value: 'low_stock', label: 'Low Stock' },
    { value: 'purchase_analysis', label: 'Purchase Analysis' },
    { value: 'usage_analysis', label: 'Usage Analysis' },
    { value: 'valuation', label: 'Valuation' }
  ]

  useEffect(() => {
    // Initialize select2 for warehouse and report type
    setTimeout(() => {
      if ($('#report_type').length && !$('#report_type').hasClass('select2-hidden-accessible')) {
        $('#report_type').select2({
          allowClear: true,
          placeholder: 'Select Report Type',
          width: '100%',
          theme: 'bootstrap4'
        })
      }
      if ($('#warehouse_id').length && !$('#warehouse_id').hasClass('select2-hidden-accessible')) {
        $('#warehouse_id').select2({
          allowClear: true,
          placeholder: 'Select Warehouse',
          width: '100%',
          theme: 'bootstrap4'
        })
      }

      // Initialize datetimepicker for date inputs using proper selector
      if ($('#start_date_picker').length && !$('#start_date_picker').data('datetimepicker')) {
        try {
          $('#start_date_picker').datetimepicker({
            format: 'MM/DD/YYYY',
            useCurrent: false,
            maxDate: moment()
          })

          // Set initial value if exists
          if (startDate) {
            $('#start_date_picker').datetimepicker('date', moment(startDate, 'MM/DD/YYYY'))
          }
        } catch (e) {
          console.error('Error initializing start_date picker:', e)
        }
      }

      if ($('#end_date_picker').length && !$('#end_date_picker').data('datetimepicker')) {
        try {
          $('#end_date_picker').datetimepicker({
            format: 'MM/DD/YYYY',
            useCurrent: false,
            maxDate: moment()
          })

          // Set initial value if exists
          if (endDate) {
            $('#end_date_picker').datetimepicker('date', moment(endDate, 'MM/DD/YYYY'))
          }
        } catch (e) {
          console.error('Error initializing end_date picker:', e)
        }
      }

      // Link date pickers
      $('#start_date_picker').off('change.datetimepicker').on('change.datetimepicker', function(e) {
        if (e.date) {
          $('#end_date_picker').datetimepicker('minDate', e.date)
          setFilters(prev => ({
            ...prev,
            start_date: e.date.format('MM/DD/YYYY')
          }))
        }
      })

      $('#end_date_picker').off('change.datetimepicker').on('change.datetimepicker', function(e) {
        if (e.date) {
          $('#start_date_picker').datetimepicker('maxDate', e.date)
          setFilters(prev => ({
            ...prev,
            end_date: e.date.format('MM/DD/YYYY')
          }))
        }
      })
    }, 200)

    return () => {
      $('#report_type').off('change')
      $('#warehouse_id').off('change')
      $('#start_date_picker').off('change.datetimepicker')
      $('#end_date_picker').off('change.datetimepicker')
    }
  }, [startDate, endDate])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFilters(prev => ({
      ...prev,
      [name]: value
    }))

    // Update select2 display if needed
    if (name === 'report_type' && $('#report_type').hasClass('select2-hidden-accessible')) {
      $('#report_type').val(value).trigger('change')
    }
    if (name === 'warehouse_id' && $('#warehouse_id').hasClass('select2-hidden-accessible')) {
      $('#warehouse_id').val(value).trigger('change')
    }
  }

  const handleApply = (e) => {
    e.preventDefault()

    // Get values from datetimepicker inputs
    const startDateInputs = $('#start_date_picker').find('input')
    const endDateInputs = $('#end_date_picker').find('input')

    const startDateVal = startDateInputs.length > 0 ? startDateInputs.val() : filters.start_date
    const endDateVal = endDateInputs.length > 0 ? endDateInputs.val() : filters.end_date

    const params = new URLSearchParams()

    if (filters.warehouse_id) params.append('warehouse_id', filters.warehouse_id)
    if (filters.report_type) params.append('report_type', filters.report_type)
    if (startDateVal) params.append('start_date', startDateVal)
    if (endDateVal) params.append('end_date', endDateVal)

    const url = `/inventory_reports?${params.toString()}`
    window.location.href = url
  }

  const handleClear = (e) => {
    e.preventDefault()
    window.location.href = '/inventory_reports'
  }

  return (
    <div id="sidebar-filter" className="sidebar filter">
      <div className="sidebar-container">
        <div className="filter-header">
          <h4>Filters</h4>
          <input
            type="reset"
            value="Clear Filters"
            className="btn btn-blue"
            onClick={handleClear}
            style={{ cursor: 'pointer' }}
          />
        </div>

        <form onSubmit={handleApply} id="filter-reports">
          <div className="row">
            <div className="form-group col-12">
              <label htmlFor="report_type">Report Type</label>
              <select
                id="report_type"
                name="report_type"
                value={filters.report_type}
                onChange={handleInputChange}
                className="form-control custom-select-allow-empty"
                data-placeholder="All Types"
                autoComplete="off"
              >
                <option value="">All Types</option>
                {reportTypes.map(type => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group col-12">
              <label htmlFor="warehouse_id">Warehouse</label>
              <select
                id="warehouse_id"
                name="warehouse_id"
                value={filters.warehouse_id}
                onChange={handleInputChange}
                className="form-control custom-select-allow-empty"
                data-placeholder="All Warehouses"
                autoComplete="off"
              >
                <option value="">All Warehouses</option>
                {warehouses && warehouses.map(warehouse => (
                  <option key={warehouse.id} value={warehouse.id}>
                    {warehouse.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group col-12">
              <label htmlFor="start_date_picker">Start Date</label>
              <div id="start_date_picker" className="input-group date" data-target-input="nearest">
                <input
                  type="text"
                  name="start_date"
                  value={filters.start_date}
                  onChange={handleInputChange}
                  className="form-control datetimepicker-input"
                  data-target="#start_date_picker"
                />
                <div className="input-group-append" data-target="#start_date_picker" data-toggle="datetimepicker">
                  <div className="input-group-text">
                    <i className="far fa-calendar-alt"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group col-12">
              <label htmlFor="end_date_picker">End Date</label>
              <div id="end_date_picker" className="input-group date" data-target-input="nearest">
                <input
                  type="text"
                  name="end_date"
                  value={filters.end_date}
                  onChange={handleInputChange}
                  className="form-control datetimepicker-input"
                  data-target="#end_date_picker"
                />
                <div className="input-group-append" data-target="#end_date_picker" data-toggle="datetimepicker">
                  <div className="input-group-text">
                    <i className="far fa-calendar-alt"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="actions col-12">
              <button
                type="submit"
                className="btn btn-primary-blue"
              >
                Apply
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

